import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export default function WhatsAppLink() {
    const { t } = useTranslation();

    return (
        <Link className="btn btn-outline-success w-auto"
            to={'https://wa.me/966508684795'} target='blank'
        >
            {t("Whatsapp")} <FontAwesomeIcon icon={faWhatsapp} className='fs-4' />
        </Link>
    )
}

export function WhatsAppLinkSmall() {
    // const { t } = useTranslation();

    return (
        // <Link className="btn btn-outline-success w-auto"
        <Link className="ps-1"
            to={'https://wa.me/966508684795'} target='blank'
        >
            <FontAwesomeIcon icon={faWhatsapp} className='whatsAppIcon-small c-darkOrange' />
        </Link>
    )
}